import React from "react";
import "./App.scss";

import { Provider } from "react-redux";
import Store from "./store";
import RouterIndex from "./routes";

function App() {
  return (
    <Provider store={Store}>
      <RouterIndex />
    </Provider>
  );
}

export default App;
